import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { ILineItemAddData } from '../../items-list/business-logic/line-item-add';
import { EmeraldErrorModal } from 'src/common/api/emerald-error';

export const handleQuantityWithBarcodeForbidden = (
  lineItemData: ILineItemAddData,
): EmeraldErrorModal => {
  return new EmeraldErrorModal({
    message: 'QuantityForbiddenMessageExeption',
    type: EmeraldDialogTypes.Warning,
    subMessage: 'QuantityForbiddenSubMessageExeption',

    subMessageArgs: {
      arg: lineItemData.lineItem?.uomCode?.toString() || '',
    },
  });
};
